export default __webpack_public_path__ + "static/media/3.e8b7ca20.jpg";